export const apiUrl = process.env.API_URL;
export const version = process.env.VERSION;
//export const imageFolderPath = '/static/InternettBilder/'
export const imageFolderPath =
  "https://heltopplagt.blob.core.windows.net/images/";
export const MVA_RATE = 0.25;
export const DELIVERY_COST = 99;
export const CUTOFF_HOUR = "13";
export const CUTOFF_HOUR_CATERING = "14";

export const MODULE_CONTRACTS = "nettmeny";
export const MODULE_CATERING = "catering";

export const CATERING_NEXTORDERDAY = 1;



// WEBPACK FOOTER //
// ./src/config.js